var __WEBPACK_NAMESPACE_OBJECT__ = require("@web3-react/walletconnect-connector");